export default function switchToBAService(
  $http,
  $location,
  $cookies,
  $window,
  NotificationService,
  sessionService,
  ENVIRONMENT,
  SWITCH_TO_COOKIE_KEY,
  SWITCH_TO_BA_CONFIG,
  SWITCH_TO_BC_CONFIG,
) {
  return { switchToBA };

  function switchToBA(merchant, additionalPath) {
    let sessionToken = '',
      defaultPath = '',
      location;

    if (!merchant.id) {
      NotificationService.error('Invalid merchant ID');
      return;
    }

    location = SWITCH_TO_BA_CONFIG.BA_LOCATION + 'switch_to_app?merchantId=' + merchant.id;

    additionalPath = additionalPath ? additionalPath : defaultPath;
    location += additionalPath;

    if (!location) {
      NotificationService.error('Invalid BA location');
      return;
    }

    $http.post(SWITCH_TO_BC_CONFIG.AUDIT_ENDPOINT + '/' + merchant.id, {}).then(function(res) {
      if (res.data) {
        sessionToken = res.data;
        if (!sessionToken) {
          NotificationService.error('Invalid session token');
          return;
        }
        $window.location = location + '&sessionToken=' + sessionToken;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/switchToBA.service.js